<div class="menubar-hoverable header-fixed menubar-pin" style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">



  <!-- BEGIN BASE-->
  <div id="base">

    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div><!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->
  <!-- BEGIN CONTENT-->
  <div id="content">
    <section class="has-actions style-default-bright">
      <div class="row">
        <div class="col-lg-12">
          <h2 class="text-primary">{{ 'schoolExpenses' | translate }}</h2>
        </div><!--end .col -->
        <div class="col-lg-6">
          <article class="margin-bottom-xxl">
            <p class="lead" style="color: #828282;">
              {{ 'knowYourExpensesToManageYourRevenue' | translate }}
            </p>
          </article>
        </div><!--end .col -->




        <div class="col-md-12 expense-overview col-md-offset-3" style="margin-top: 2em;">
          <div class="col-md-3">
            <div class="col-md-12 card overview-data">
              <div class="col-md-3 text-center" style="    background: #E91E63;">
                <i class="fa fa-area-chart"></i>
              </div>
              <div class="col-md-9">
                <h4><b>{{currency}} </b>{{getExpenseTotalAmount || 0}}</h4>
                <p>{{ 'totalExpenses' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="col-md-12 card overview-data">
              <div class="col-md-3 text-center" style="    background: #8BC34A;">
                <i class="fa fa-credit-card"></i>
              </div>
              <div class="col-md-9">
                <h4><b>{{currency}} </b>{{getExpenseTotalTaxAmount || 0}}</h4>
                <p>{{ 'totalTax' | translate }}</p>
              </div>
            </div>
          </div>
        </div>


        <!-- BEGIN LAYOUT LEFT ALIGNED -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-head">
              <ul class="nav nav-tabs" data-toggle="tabs" style="cursor: pointer;padding: 0;">
                <li *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW != 'ENABLED'" class="active tab-categories" style="width: 100%;text-align: center"><a data-target="#tab-categories" data-toggle="tab">{{ 'expenses' | translate }}</a></li>
                <li *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'" class="active tab-categories" style="width: 50%;text-align: center"><a (click)="fetchExpensesInFinancialTerms()" data-target="#tab-categories" data-toggle="tab">{{ 'expenses' | translate }}</a></li>
                <li *ngIf="academicPermissions.FINANCIAL_TERMS_FEE_OVERVIEW == 'ENABLED'" class="tab-classes" style="width: 50%;text-align: center"><a (click)="fetchExpensesInFinancialTerms()" data-target="#tab-finance-terms" data-toggle="tab">{{ 'expensesInFinancialTermBasis' | translate }}</a></li>
              </ul>
            </div><!--end .card-head -->

            <div class="card-body tab-content" style="padding: 0;">
              <div class="tab-pane active" id="tab-categories">
                <div class="col-md-12" style="padding: 35px 20px 15px 20px; text-align: center;">
                  <h3 style="font-weight: 100;margin: 0;color: #777777;margin-bottom: 5px;">{{ 'trackYourExpensesToSeeHowYouSpendYourMoney' | translate }} </h3>
                  <h4 style="color: #6b6b6b;font-weight: 300;margin-right: 10px;"> {{ 'wantToAddAnExpense' | translate }} </h4>
                  <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="offcanvas" (click)="openExpenseOffCanvas()" data-target="#offcanvas-add-newexpense" style="padding: 0px 75px;">{{ 'addAnExpense' | translate }}</button>
                </div>
                <div class="col-md-12">
                  <div class="col-md-12 table-responsive" style="padding: 25px 30px;min-height: 400px;">
                    <table id="expenseview-detail-table"  class="display" cellspacing="0" width="100%">
                      <thead>
                      <tr>
                        <th style="padding-left: 10px;">{{ 'paymentDate' | translate }}</th>
                        <th style="padding-left: 10px;">{{ 'payee' | translate }}</th>
                        <th style="padding-left: 10px;">{{ 'type' | translate }}</th>
                        <th style="padding-left: 10px;">{{ 'totalBeforeTax' | translate }}({{currency}})</th>
                        <th style="padding-left: 10px;">{{ 'totalTax' | translate }}({{currency}})</th>
                        <th style="padding-left: 10px;">{{ 'totalAfterTax' | translate }}({{currency}})</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let payee of getExpensePayeeListTble" (click)="openExpenseOffCanvasForEdit(payee.pkExpenseId)" data-toggle="offcanvas" data-target="#offcanvas-edit-expense" style ="cursor:pointer;">
                        <td>{{payee.PaymentDate}}</td>
                        <td>{{payee.PayeeName}}</td>
                        <td>{{payee.PayeeType}}</td>
                        <td>{{payee.SubTotal}}</td>
                        <td>{{payee.Totaltax}}</td>
                        <td>{{payee.Total}}</td>
                        <span></span><br>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="tab-finance-terms">
                <table id="financial-term-basis-list" class="table table-striped " style="    width: 80%;
    margin-top: 3%;
    margin-left: 10%;">
                  <thead>
                  <tr>
                    <th>{{ 'financialTerm' | translate }}</th>
                    <th>{{ 'startDate' | translate }}</th>
                    <th>{{ 'endDate' | translate }}</th>
                    <th>{{ 'totalExpenses' | translate }}({{currency}})</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let g of schoolFinanacialTermFeeOverivewList" [style.display]="!schoolFinanacialTermFeeOverivewListProcessing ? '' : 'none'">
                    <td>{{g.TermName}}</td>
                    <td>{{g.StartDate | date: 'dd-MMM-yyyy'}}</td>
                    <td>{{g.EndDate | date: 'dd-MMM-yyyy'}}</td>
                    <td>{{g.totalExpenses}}</td>
                  </tr>
                  <tr *ngIf="schoolFinanacialTermFeeOverivewListProcessing" style="text-align: center;">
                    <td colspan="5"><i class="fa fa-spinner fa-spin"></i></td>
                  </tr>
                  <tr *ngIf="!schoolFinanacialTermFeeOverivewListProcessing && schoolFinanacialTermFeeOverivewList.length == 0">
                    <td colspan="5" style="text-align: center;">
                      {{ 'thereNoFinancialTermsToShow' | translate }}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div><!--end .card -->
        </div><!--end .col -->
        <!-- END LAYOUT LEFT ALIGNED -->
      </div>








    </section>
  </div><!--end #content-->
  <!-- END CONTENT -->




  <!-- Menubar -->
  <!--  -->
    <!--START OFF CANVAS-->
<div class="offcanvas">

  <!--start expense offcanvas  for adding-->
  <div id="offcanvas-add-newexpense" class="offcanvas-pane width-12" style="width:1000px;overflow-x: hidden;">
    <div class="offcanvas-head" style="padding: 0;">
      <!-- Student details -->
      <div id="particles-view-student" class="row" style="background: var(--secondary-btn-bg-color);height: 13em;">
        <div class="particles-content">
          <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
            <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
          </div>
          <div class="col-md-12 text-center">
            <p class="lead text-center" style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'schoolExpenses' | translate }}</p>
            <img src="assets/img/student-avatar.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
            <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'manageTheExpenseHere' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'expenses' | translate }}</h4>
        </div>
       <!-- <div class="col-md-12">
          <h4 class="lead pull-right" style="margin: -28px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">Ref.no<input  type="text" [(ngModel)]="addExpense.ReferenceNo" style="width: 76px" class="no-spin" name="refno"></h4>
        </div>-->
      </div>
      <div class="row" style="padding: 0em 1em;">
        <div class="col-md-6">
          <div style="padding: 0em 0em;">
            <label>{{ 'choosePayee' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its is for selecting payee for this expense" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="hide">
            <button id="onchangeformodal" type="button" data-toggle="modal" data-target="#add-expense" class="btn btn-raised ink-reaction btn-info openfor-payee" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
          </div>
          <div class="form-group">
            <select required id="select-class-add-fee" [(ngModel)]="addExpense.PayeeId"  (change)="openAddExpensePopUp($event.target.value)" name="select-section-add-fee"  class="form-control"  style="border: 1px solid #b9b6b6;color: #080808;font-size: 14px;">
              <option value="" disabled selected hidden>{{ 'pleaseChoosePayee' | translate }}</option>
              <option value="0"><i class="fa fa-plus" aria-hidden="true"></i>{{ 'addNew' | translate }}</option>
              <option *ngFor="let pay of getExpPayeeList" value="{{pay.pkExpensePayeeTypeId}}">{{pay.PayeeName}}</option>
            </select><div class="form-control-line"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div style="padding: 0em 0em;">
            <label>{{ 'referenceNo' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its an unique number to track your expense" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="form-group">
            <input  type="text" [(ngModel)]="addExpense.ReferenceNo" [placeholder]="'refrenceNumber' | translate" style="width: 467px;height: 36px;" class="no-spin" name="refno">
          </div>
        </div>
      </div>
      <div class="row" style="padding: 0em 1em;">
       <div class="col-md-6">
        <div>
          <label>{{ 'paymentMethod' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its an payment method for the expense to choose" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
         <div class="hide">
           <button id="onchangeformodalpm" type="button" data-toggle="modal" data-target="#add-new-paymet-method" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
         </div>
        <div class="form-group">
          <select class="form-control" [(ngModel)]="addExpense.PaymentMethodId" id="select-payment-method" (change)="OpenpaymentMethodPopUp($event.target.value)" name="select-section-add-fee" required="" style="border: 1px solid #b9b6b6;color: #080808;font-size: 14px;">
            <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
            <option value="0">{{ 'addNew' | translate }}</option>
            <option *ngFor="let met of getExpensePaymentMethodLists" value="{{met.pkExpensePaymentMethodId}}">{{met.CardName}}</option>
          </select>
        </div>
       </div>
        <div class="col-md-6">
          <div>
            <label>{{ 'paymentDate' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: It is for selecting payment date on which the expense have been paid" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="form-group">
            <input class="form-control dateautoclose" name="payment-date" [placeholder]="'selectDate' | translate" data-date-end-date="0d" data-date-format="dd/mm/yyyy" data-provide="datepicker" id="payment-date" style="border: 1px solid #b9b6b6;" type="text" value="">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="padding: 15px 25px;">
          <form class="form student-detail-summary">
            <div class="row" style="margin: 0;">
            </div>
          </form>
        </div>
      </div>
      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'addExpenses' | translate }}</h4><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its is for adding expense details" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
      </div>
        <div class="row" style="padding: 20px 0px;">
          <div class="hide">
            <button id="onchangeformodalAcc" type="button" data-toggle="modal" data-target="#add-new-accounttype" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
          </div>
          <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
          <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
            <table id="TermConfig_new" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
              <thead style="background: var(--brand-primary-color);color: white;">
              <tr style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 's.no' | translate }}</b></th>
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 'account' | translate }}</b></th>
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'description' | translate }}</th>
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'amount' | translate }}({{currency}})</th>
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'tax' | translate }}</th>
                <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"></th>
              </tr>
              </thead>
              <tbody>
              <tr class="gradeX" *ngFor="let ex of addExpense.addExpenseAcc;let i = index;"  style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:3em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{i+1}}</td>
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 22em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                  <select class="form-control" name="accountType" (change)="addNewAccountType($event.target.value,i)" [(ngModel)]="ex.AccountTypeId" id="{{'accpopup'+i}}" style="font-size: 14px;">
                    <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                    <option value="0">{{ 'addNew' | translate }}</option>
                    <option *ngFor="let ac of getExpenseAccountTypeListForTableList" value="{{ac.pkExpenseAccountId}}">{{ac.Name}}</option>
                  </select>
                </td>
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 23em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="text" [(ngModel)]="ex.Description"  style="width: 33em" class="no-spin" name="description"></td>
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 6em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="number" min="0" [(ngModel)]="ex.Amount" (keyup)="calculateAccTypeItemTypeAmountForExpense();iNegativeNumForAcc(ex)" style="width: 76px" class="no-spin" name="amount"></td>
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 17em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><!--<input  type="number" min="0" max="100" [(ngModel)]="ex.Tax" (keyup)="calculateAccTypeTaxForExpense(ex.Tax);iNegativeNumForAcc(ex)" style="width:4em" class="no-spin" name="tax">-->
                  <select class="form-control" name="taxType" (change)="calculateAccTypeTaxForExpense()" [(ngModel)]="ex.Tax" style="font-size: 14px;">
                    <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                    <option value="0">{{ 'exemptIgst0' | translate }}</option>
                    <option value="5">{{ '5.0Gst5' | translate }}</option>
                    <option value="18">{{ '18.0Igst18' | translate }}</option>
                    <option value="0">{{ 'exemptGst0' | translate }}</option>
                    <option value="0">{{ '0Igst0' | translate }}</option>
                    <option value="28">{{ '28Gst28' | translate }}</option>
                    <option value="12">{{ '12Gst12' | translate }}</option>
                    <option value="0">{{ '0Gst0' | translate }}</option>
                    <option value="0">{{ 'outOfScope0' | translate }}</option>
                    <option value="28">{{ '28Igst28' | translate }}</option>
                    <option value="12">{{ '12Igst12' | translate }}</option>
                    <option value="18">{{ '18Gst18' | translate }}</option>
                    <option value="5">{{ '5Igst5' | translate }}</option>
                  </select>
                </td>
                <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 3em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><i [style.display]="i==0 ? 'none':''" class="fa fa-trash" aria-hidden="true" (click)="removeRow(i)" style="cursor: pointer"></i></td>
              </tr>
              </tbody>
            </table>
            <div>
              <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;float: left" (click)="addNewLine()">{{ 'addLines' | translate }}</button>
            </div>
          </div>
        </div>
      <!--second table for item details-->

      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'itemDetails' | translate }}</h4><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: It is for adding expense in detail for an item(optional)" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
      </div>

      <div class="row" style="padding: 20px 0px;">
        <div class="hide">
          <button id="onchangeformodalItem" type="button" data-toggle="modal" data-target="#selectservice" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
        </div>
        <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
        <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
          <table id="itemDetails" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
            <thead style="background: var(--brand-primary-color);color: white;">
            <tr style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 's.no' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 'product/service' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'qty' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'rate' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'amount' | translate }}({{currency}})</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'tax' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="gradeX" *ngFor="let ex of addExpense.addExpenseItemDetail;let i = index;"  style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">

              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:3em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{i+1}}</td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 22em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                <select class="form-control" name="accountType" (change)="addNewServiceType($event.target.value,i)" [(ngModel)]="ex.ItemId" id="{{'servicePopUp'+'_'+i}}" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{'addNew' | translate}}</option>
                  <option *ngFor="let ser of getExpenseItemServiceListForTble" value="{{ser.pkExpenseServiceTypeId}}">{{ser.Name}}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="number" min="0" [(ngModel)]="ex.Qty" (keyup)="iNegativeNumForItem(ex)" style="width: 76px" class="no-spin" name="quantity" id="getQty"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="number" min="0" [(ngModel)]="ex.Rate" (keyup)="calculateAmnt();iNegativeNumForItem(ex)"  style="width: 76px" class="no-spin" name="rate" id="getRate"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input disabled type="number"  [(ngModel)]="ex.Amount" style="width: 76px" class="no-spin" name="amount" id="{{'getAmnt'+'_'+i}}"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><!--<input  type="number" min="0" style="width: 76px" class="no-spin" name="tax" id="{{'getTaxAmnt'+'_'+i}}">-->
                <select class="form-control" name="taxType" (change)="calculateAccTypeTaxForExpense()" [(ngModel)]="ex.Tax" id="{{'getTaxAmnt'+'_'+i}}" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{ 'exemptIgst0' | translate }}</option>
                  <option value="5">{{ '5.0Gst5' | translate }}</option>
                  <option value="18">{{ '18.0Igst18' | translate }}</option>
                  <option value="0">{{ 'exemptGst0' | translate }}</option>
                  <option value="0">{{ '0Igst0' | translate }}</option>
                  <option value="28">{{ '28Gst28' | translate }}</option>
                  <option value="12">{{ '12Gst12' | translate }}</option>
                  <option value="0">{{ '0Gst0' | translate }}</option>
                  <option value="0">{{ 'outOfScope0' | translate }}</option>
                  <option value="28">{{ '28Igst28' | translate }}</option>
                  <option value="12">{{ '12Igst12' | translate }}</option>
                  <option value="18">{{ '18Gst18' | translate }}</option>
                  <option value="5">{{ '5Igst5' | translate }}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><i [style.display]="i==0 ? 'none':''" class="fa fa-trash" aria-hidden="true" (click)="removeRowForItem(i)" style="cursor: pointer"></i></td>
            </tr>
            </tbody>
          </table>
          <div>
            <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;float: left" (click)="addNewLineForItem()">{{ 'addLines' | translate }}</button>
          </div>
          <div class="col-md-4 text-right" style="padding: 23px 0px;;float:right;">
            <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;"><b>{{ 'subtotal' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{subTotal}}</h4>
          </div>
          <div class="row">
            <div class="col-md-12" style="margin-top: -3em;">
              <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;"><b>{{ 'totalTax' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{taxAmnt}}</h4>
            </div>
            <div class="col-md-12" style="margin-top: -3em;">
              <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;margin-top: 3em"><b>{{ 'total' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{TotalAmountForExpWithTax}}</h4>
            </div>
          </div>
        </div>
      </div>

      <!--second table for item details-->

      <div class="col-md-4 text-right" style="padding: 23px 0px;;float:right;">
        <button type="button" class="btn btn-raised ink-reaction btn-info cancelupdateorder" data-dismiss="offcanvas" id="addExpenseButtonCancel">{{ 'cancel' | translate }}</button>
        <button type="button" id="addExpenseButton" class="tttttttt btn btn-raised ink-reaction btn-info" (click)="addExpenseForm()">{{ 'save' | translate }}</button>
      </div>
    </div>
  </div>
  <!--end expense offcanvas for adding-->

  <!--start expense offcanvas  for edit-->
  <div id="offcanvas-edit-expense" data-backdrop="false" class="offcanvas-pane width-12" style="width:1000px;overflow-x: hidden;">
    <div class="offcanvas-head" style="padding: 0;">
      <!-- Student details -->
      <div id="particles-edit-student" class="row" style="background: var(--secondary-btn-bg-color);height: 13em;">
        <div class="particles-content">
          <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
            <h3 class="pull-right" style="color: white;cursor: pointer;"><i class="fa fa-close" (click)="saveBeforeClosingOperation()"></i></h3>
          </div>
          <div class="col-md-12 text-center">
            <p class="lead text-center" style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'schoolExpenses' | translate }}</p>
            <img src="assets/img/student-avatar.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
            <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'view' | translate }} <b>/</b> {{ 'manageTheExpenseHere' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'expenses' | translate }}</h4>
        </div>
        <!--<div class="col-md-12">
          <h4 class="lead pull-right" style="margin: -28px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">Ref.no<input  type="text" [(ngModel)]="selectedExpenseIdDetails.ReferenceNumber" [ngModelOptions]="{standalone: true}"  style="width: 76px" class="no-spin" name="refno"></h4>
        </div>-->
      </div>
      <div class="row" style="padding: 0em 1em;">
        <div class="col-md-6">
          <div style="padding: 0em 0em;">
            <label>{{ 'choosePayee' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its is for selecting payee for this expense" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="hide">
            <button id="onchangeformodaledit" type="button" data-toggle="modal" data-target="#add-expense" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
          </div>
          <div class="form-group">
            <select required id="select-class-edit-fee" [(ngModel)]="selectedExpenseIdDetails.pkExpensePayeeTypeId" [ngModelOptions]="{standalone: true}" name="payeename" value="{{selectedExpenseIdDetails.pkExpensePayeeTypeId}}" (change)="openAddExpensePopUpEdit($event.target.value)" name="select-section-add-fee"  class="form-control"  style="border: 1px solid #b9b6b6;color: #080808;font-size: 14px;">
              <option value="" disabled selected hidden>{{ 'pleaseChoosePayee' | translate }}</option>
              <option value="0"><i class="fa fa-plus" aria-hidden="true"></i>{{ 'addNew' | translate }}</option>
              <option *ngFor="let pay of getExpPayeeList" value="{{pay.pkExpensePayeeTypeId}}">{{pay.PayeeName}}</option>
            </select><div class="form-control-line"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div style="padding: 0em 0em;">
            <label>{{ 'referenceNo' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its an unique number to track your expense" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="form-group">
            <input  type="text" [(ngModel)]="selectedExpenseIdDetails.ReferenceNumber" [ngModelOptions]="{standalone: true}"  style="width: 467px;height: 36px;" class="no-spin" name="refno">
          </div>
        </div>
      </div>
      <div class="row" style="padding: 0em 1em;">
        <div class="col-md-6">
          <div>
            <label>{{ 'paymentMethod' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its an payment method for the expense to choose" style="padding: 0em 5px;" aria-hidden="true"></i></span>
          </div>
          <div class="hide">
            <button id="onchangeformodalpmedit" type="button" data-toggle="modal" data-target="#add-new-paymet-method" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
          </div>
          <div class="form-group">
            <select class="form-control" id="select-payment-method-selected" [(ngModel)]="selectedExpenseIdDetails.pkExpensePaymentMethodId" [ngModelOptions]="{standalone: true}" name="paymentmethod" value="{{selectedExpenseIdDetails.pkExpensePaymentMethodId}}" (change)="OpenpaymentMethodPopUpEdit($event.target.value)" name="select-section-add-fee" required="" style="border: 1px solid #b9b6b6;color: #080808;font-size: 14px;">
              <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
              <option value="0">{{ 'addNew' | translate }}</option>
              <option *ngFor="let met of getExpensePaymentMethodLists" value="{{met.pkExpensePaymentMethodId}}">{{met.CardName}}</option>
            </select>
          </div>
        </div>
      <div class="col-md-6">
        <div>
          <label>{{ 'paymentDate' | translate }}</label><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: It is for selecting payment date on which the expense have been paid" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
        <div class="form-group">
          <input class="form-control dateautoclose" name="payment-date" [(ngModel)]="selectedExpenseIdDetails.PaymentDate" placeholder="select date" data-date-end-date="0d" data-date-format="dd/mm/yyyy" data-provide="datepicker" id="selected-payment-date" style="border: 1px solid #b9b6b6;" type="text" value="">
        </div>
      </div>
      </div>
      <div class="row">
        <div class="col-md-12" style="padding: 15px 25px;">
          <form class="form student-detail-summary">
            <div class="row" style="margin: 0;">
            </div>
          </form>
        </div>
      </div>
      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'addExpenses' | translate }}</h4><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: Its is for adding expense details" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
      </div>
      <div class="row" style="padding: 20px 0px;">
        <div class="hide">
          <button id="onchangeformodalAccEdit" type="button" data-toggle="modal" data-target="#add-new-accounttype" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{'modalOpen'}}</button>
        </div>
        <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
        <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
          <table id="EditExpense" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
            <thead style="background: var(--brand-primary-color);color: white;">
            <tr style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 's.no' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 'account' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'description' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'amount' | translate }}({{currency}})</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'tax' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="gradeX" *ngFor="let ex of selectedExpenseIdDetailsForAccount;let i = index;"  style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">

              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:3em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{i+1}}</td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:22em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                <select class="form-control" name="accountType" (change)="addNewAccountTypeEdit($event.target.value,i)" [(ngModel)]="ex.fkExpenseAccountId" id="{{'accEdit'+'_'+i}}" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{ 'addNew' | translate }}</option>
                  <option *ngFor="let ac of getExpenseAccountTypeListForTableList" value="{{ac.pkExpenseAccountId}}">{{ac.Name}}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:23em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="text" [(ngModel)]="ex.Description"  style="width: 33em" class="no-spin" name="description"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:6em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input  type="number" min="0" [(ngModel)]="ex.Amount" (keyup)="calculateAccTypeItemTypeAmountForExpenseForEdit();iNegativeNumForAccEdit(ex)" style="width: 76px" class="no-spin" name="amount" id="{{'getAmntEdit'+'_'+i}}"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:17em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><!--<input  type="number" min="0" [(ngModel)]="ex.Tax" (keyup)="calculateAccTypeTaxForExpenseForEdit(ex.Tax);iNegativeNumForAccEdit(ex)" style="width: 4em" class="no-spin" name="tax" id="{{'getTax'+'_'+i}}">-->
                <select class="form-control" name="taxType" (change)="calculateAccTypeTaxForExpenseForEdit()" [(ngModel)]="ex.Tax" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{ 'exemptIgst0' | translate }}</option>
                  <option value="5">{{ '5.0Gst5' | translate }}</option>
                  <option value="18">{{ '18.0Igst18' | translate }}</option>
                  <option value="0">{{ 'exemptGst0' | translate }}"</option>
                  <option value="0">{{ '0Igst0' | translate }}</option>
                  <option value="28">{{ '28Gst28' | translate }}</option>
                  <option value="12">{{ '12Gst12' | translate }}</option>
                  <option value="0">{{ '0Gst0' | translate }}</option>
                  <option value="0">{{ 'outOfScope0' | translate }}</option>
                  <option value="28">{{ '28Igst28' | translate }}</option>
                  <option value="12">{{ '12Igst12' | translate }}</option>
                  <option value="18">{{ '18Gst18' | translate }}</option>
                  <option value="5">{{ '5Igst5' | translate }}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width:3em;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><i [style.display]="i==0 ? 'none':''" class="fa fa-trash" (click)="getDeleteLineIdForAcc(ex,i)" aria-hidden="true" style="cursor: pointer"></i></td>
            </tr>
            </tbody>
          </table>
          <div>
            <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;float: left" (click)="addNewRow()">{{ 'addLines' | translate }}</button>
          </div>
        </div>
      </div>
      <!--second table for item details-->

      <div class="row" style="background: #f1f1f1;margin-bottom: 2em;">
        <div class="col-md-12">
          <h4 class="lead pull-left" style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">{{ 'itemDetails' | translate }}</h4><span><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: It is for adding expense in detail for an item(optional)" style="padding: 0em 5px;" aria-hidden="true"></i></span>
        </div>
      </div>

      <div class="row" style="padding: 20px 0px;">
        <div class="hide">
          <button id="onchangeformodalItemEdit" type="button" data-toggle="modal" data-target="#selectservice" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'modalOpen' | translate }}</button>
        </div>
        <!-- <div *ngIf="termFeeConfigurations.length == 0">Please add fee in fees board</div>-->
        <div class="table-responsive" style="border: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;padding: 1em 1em;">
          <table id="itemDetailsForEdit" class="table table-striped" style="border-left: 1px solid #b9b6b6;">
            <thead style="background: var(--brand-primary-color);color: white;">
            <tr style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 's.no' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><b>{{ 'product/service' | translate }}</b></th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'qty' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'rate' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'amount' | translate }}({{currency}})</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{ 'tax' | translate }}</th>
              <th style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"></th>
            </tr>
            </thead>
            <tbody>
            <tr class="gradeX" *ngFor="let ex of selectedExpenseIdDetailsForItem;let i = index;"  style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6">

              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">{{i+1}}</td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">
                <select class="form-control" name="accountType" id="{{'serviceEdit'+'_'+i}}" (change)="addNewServiceTypeEdit($event.target.value,i)" [(ngModel)]="ex.fkExpenseServiceTypeId" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{ 'addNew' | translate }}</option>
                  <option *ngFor="let ser of getExpenseItemServiceListForTble" value="{{ser.pkExpenseServiceTypeId}}">{{ser.Name}}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input [(ngModel)]="ex.Quantity" type="number" min="0" (keyup)="iNegativeNumForItemForEdit(ex)" style="width: 76px" class="no-spin" name="quantity" id="{{'getQtyEdit'+'_'+i}}"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input [(ngModel)]="ex.Rate" type="number" min="0" style="width: 76px" class="no-spin" name="rate" (keyup)="calculateAmntForEdit(ex);iNegativeNumForItemForEdit(ex)" id="{{'getRateEdit'+'_'+i}}"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><input [(ngModel)]="ex.ItemAmount" disabled type="number"  style="width: 76px" class="no-spin" name="amount" id="{{'itemAmntForEdit'+'_'+i}}"></td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><!--<input [(ngModel)]="ex.Tax" min="0" type="number" (keyup)="calculateAccTypeTaxForExpenseForEdit(ex);iNegativeNumForItemForEdit(ex)" style="width: 76px" class="no-spin" name="tax" id="{{'itemTxEdt'+'_'+i}}">-->
                <select class="form-control" name="taxType" (change)="calculateAccTypeTaxForExpenseForEdit()" [(ngModel)]="ex.Tax" style="font-size: 14px;">
                  <option disabled="" hidden="" selected="" value="">{{ 'pleaseChoose' | translate }}</option>
                  <option value="0">{{ 'exemptIgst0' | translate }}</option>
                  <option value="5">{{ '5.0Gst5' | translate }}</option>
                  <option value="18">{{ '5.0Gst5' | translate }}</option>
                  <option value="0">{{ 'exemptGst0' | translate }}</option>
                  <option value="0">{{ '0Igst0' | translate }}</option>
                  <option value="28">{{ '28Gst28' | translate }}</option>
                  <option value="12">{{ '12Gst12' | translate }}</option>
                  <option value="0">{{ '0Gst0' | translate }}</option>
                  <option value="0">{{ 'outOfScope0' | translate }}</option>
                  <option value="28">{{ '28Igst28' | translate }}</option>
                  <option value="12">{{ '12Igst12' | translate }}</option>
                  <option value="18">{{ '18Gst18' | translate }}</option>
                  <option value="5">{{ '5Igst5' | translate }}</option>
                </select>
              </td>
              <td style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;max-width: 100%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;"><i [style.display]="i==0 ? 'none':''" class="fa fa-trash" aria-hidden="true" (click)="deleteItemLine(ex,i)" style="cursor: pointer"></i></td>
            </tr>
            </tbody>
          </table>
          <div>
            <button type="button" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;float: left" (click)="addNewRowForItem()">{{ 'addLines' | translate }}</button>
          </div>
          <div class="col-md-4 text-right" style="padding: 23px 0px;;float:right;">
            <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;"><b>{{ 'subtotal' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{selectedExpenseIdDetails.SubTotal}}</h4>
          </div>
          <div class="row">
            <div class="col-md-12" style="margin-top: -3em;">
              <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;"><b>{{ 'totalTax' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{selectedExpenseIdDetails.Totaltax}}</h4>
            </div>
            <div class="col-md-12" style="margin-top: -3em;">
              <h4 class="lead" style="float:right;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;margin-top: 3em"><b>{{ 'total' | translate }}</b> &nbsp;&nbsp;   <b>{{currency}}</b> {{selectedExpenseIdDetails.Total}}</h4>
            </div>
          </div>
        </div>
      </div>

      <!--second table for item details-->

      <div class="col-md-4 text-right" style="padding: 23px 0px;;float:right;">
        <button type="button" class="btn btn-raised ink-reaction btn-info cancelupdateorder" (click)="saveBeforeClosingOperation()" id="editExpenseButtonCancel">{{ 'cancel' | translate }}</button>
        <button type="button" class="btn btn-raised ink-reaction btn-info hide" data-dismiss="offcanvas" id="closeOffcanvas">{{ 'cancel' | translate }}</button>
        <button type="button" id="editExpenseButton" class="btn btn-raised ink-reaction btn-info" (click)="updateExpense()">{{ 'update' | translate }}</button>
      </div>
    </div>
  </div>
  <!--end expense offcanvas for edit-->

</div>
    <!--END OFF CANVAS-->

<!--modal start-->


    <!--start of product/service info modal-->
    <div class="modal fade" (click)="resetValueToOpenPopUpForsr()" id="selectservice" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="col-md-12 text-center" id="selectservice1" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 9.4em 0em;">
            <img src="images_ext/default.gif">
          </div>
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93px 0em;">
           <!-- <img src="images_ext/double-directional-arrow.png">-->
            <h3>{{ 'serviceInformation' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
            <button id="selectservicepopupclose" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" (click)="resetValueToOpenPopUpForsr();" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <input type="text" class="form-control route_Name" [(ngModel)]="addExpenseItemDetailsFortableLists.Name" id="compo1" name="routename" style="font-size: small;">
                <label for="compo1" style="font-size: small;">{{ 'name' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control route_Name" [(ngModel)]="addExpenseItemDetailsFortableLists.SKU" id="componen" name="routename" style="font-size: small;">
                <label for="componen" style="font-size: small;">{{ 'sku' | translate }}</label>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="addItemServiceBtn" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="addExpenseItemDetailsForTableList()">{{ 'save' | translate }}</button>
                <button type="button" id="addItemServiceCnclBtn" (click)="resetValueToOpenPopUpForsr()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--start of product/service info modal-->

    <!--start of add new paymet method modal-->
    <div class="modal fade" (click)="resetValueToOpenPopUpForPM();resetValueToOpenPopUpForEditExpPM()" id="add-new-paymet-method" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="col-md-12 text-center" id="addpaymentmethod" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 9.4em 0em;">
            <img src="images_ext/default.gif">
          </div>
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 57px 0em;">
            <!--<img src="images_ext/double-directional-arrow.png">-->
            <h3>{{ 'newPaymentMethod' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
            <button id="addpaymentmethodpopupclose" (click)="resetValueToOpenPopUpForPM();resetValueToOpenPopUpForEditExpPM()" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <input type="text" class="form-control route_Name" [(ngModel)]="addExpensePaymentMethods.CardName" id="component45" name="routename" style="font-size: small;">
                <label for="component45" style="font-size: small;">{{ 'name' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
              <!--<div class="checkbox checkbox-styled">
                <label>
                  <input type="checkbox" value="">
                  <span>This is a credit card</span>
                </label>
              </div>-->
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="addPaymentMethodBtn" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="addExpensePaymentMethod()">{{ 'save' | translate }}</button>
                <button type="button" id="addPaymentMethodBtnCncl" (click)="resetValueToOpenPopUpForPM();resetValueToOpenPopUpForEditExpPM()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--start of add new paymet method modal-->


    <!--start of add account type details modal-->
    <div class="modal fade" (click)="resetValueToOpenPopUpForACC()" id="add-new-accounttype" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="col-md-12 text-center" id="accounttype" style="display: none;position: absolute;background: rgba(255, 255, 255, 0.68);z-index: 999;padding: 9.4em 0em;">
            <img src="images_ext/default.gif">
          </div>
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;">
            <!--<img src="images_ext/double-directional-arrow.png">-->
            <h3>{{ 'account' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;">
            <button id="accounttypepopupclose" (click)="resetValueToOpenPopUpForACC()" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="select18" name="type"  [(ngModel)]="addExpenseAccountDetailsFortableLists.CategoryType" class="form-control startpoint"  style="font-size: small;">
                  <option value="" disabled selected hidden></option>
                  <option value="expense">{{ 'expense' | translate }}</option>
                  <option value="other expense">{{ 'otherExpense' | translate }}</option>
                </select>
                <label for="select18" style="font-size: small;">{{ 'categoryType' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control route_Name" [(ngModel)]="addExpenseAccountDetailsFortableLists.Name" id="component1" name="routename" style="font-size: small;">
                <label for="component1" style="font-size: small;">{{ 'name' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="addExpAccDtlFrTbleBtn" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" (click)="addExpenseAccountDetailsFortableList()">{{ 'save' | translate }}</button>
                <button type="button" id="addExpAccDtlFrTbleCncl" (click)="resetValueToOpenPopUpForACC()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--end of add account type details modal-->







    <!--start of add expense modal-->
    <div class="modal fade" (click)="resetValueToOpenPopUp();resetValueToOpenPopUpForEditExp()" id="add-expense" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="col-md-12" style="background-color: white;padding: 0px 20px;">
            <div class="row" style="padding: 10px 10px;">
              <img src="images_ext/discount.png">
              <h3 style="margin-top: -27px;margin-left: 11em;color: var(--brand-primary-color);">{{ 'addNewPayee' | translate }}</h3>
            </div>
            <button id="addexpensepopupclose" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -4em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" (click)="resetValueToOpenPopUp();resetValueToOpenPopUpForEditExp()" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group" style="padding-top: 16px !important;">
                <select required id="select14" [(ngModel)]="addExpensePayees.PayeeType" (change)="getPayeeType()" name="type" class="form-control startpoint"  style="font-size: small;">
                  <option value="" disabled selected hidden></option>
                  <option value="SUPPLIER">{{ 'supplier' | translate }}</option>
                  <option value="CUSTOMER">{{ 'customer' | translate }}</option>
                  <option value="EMPLOYEE">{{ 'employee' | translate }}</option>
                </select>
                <label for="select14" style="font-size: small;">{{ 'type' | translate }}</label>
              </div>
              <div class="form-group search-input hide"  style="padding-top: 0px !important;"><i class="fa fa-info-circle"  data-toggle="tooltip" title="Note: If searched staff is not available, please go to staff section and add the staff" style="padding: 0em 80px;;" aria-hidden="true"></i>
                <input type="text" id="searchStaff" name="search-staff" (change)="searchstaffToGetPayee(searchName)" [(ngModel)]="searchName" class="form-control"  placeholder="Search staff to assign" data-role="tagsinput" style="font-size: small;font-weight: lighter;border: 0px;">
                <label style="font-size: small;">{{ 'searchStaff' | translate }}</label>
              </div>
              <div *ngIf="addStaffMsg" class="form-group">
                <span style="color: #F44336;">*</span><span><b>{{ 'noStaffFoundPleaseGoToStaffSectionToAddStaff' | translate }}</b></span>
              </div>
              <div class="searchField-sf" id="staffSearchResult"  style="z-index: 999">
                <div class="col-md-12 card search-staff" *ngFor="let staff of searchStaffNameData" (click)="getSelectedStaffName(staff)"  style="margin: 0px;cursor: pointer;z-index: 999;">
                  <div class="col-md-4">
                    <img src="{{staff.staffImage}}" class="img-circle" alt="staff" width="60" height="60" style="margin-top: 6px;">
                  </div>
                  <div class="col-md-8">
                    <h4 class="staff-Name">{{staff.staffName}}</h4>
                    <p class="designation" style="margin-top: -15px;">{{staff.designation}}</p>
                    <p class="mob-number" style="margin-top: -20px;">{{staff.mobileNumber}}</p>
                  </div>
                </div>
              </div>
              <div class="form-group nameField" id="nameHideFrPye">
                <input type="text" class="form-control" [(ngModel)]="addExpensePayees.PayeeName" name="studentCategoryName" id="payeeName">
                <label style="font-size: small;">{{ 'name' | translate }}</label>
              </div>
              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" class="btn btn-raised ink-reaction btn-info" id="addPayeeButton" style="padding: 3px 20px;" (click)="addExpensePayee()">{{ 'save' | translate }}</button>
                <button type="button" (click)="resetValueToOpenPopUp();resetValueToOpenPopUpForEditExp()" class="btn btn-raised ink-reaction btn-info" id="addPayeeButtonClose" style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'cancel' | translate }}</button>
              </div>
            </form>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <!--End of add expense modal-->

    <!--start delete account type list from delete icon-->

    <div id="savebeforeclosing" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="margin-top: 190px">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> {{ 'save/update' | translate }}</h3>
            <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
            <p style="font-size: 19px;margin-left: 6px;padding: 29px 30px;">{{ 'pleaseClickUpdateButtonToSaveTheChanges' | translate }}</p>
            <div style="padding:0px 240px;;    margin-top: -12px;">
              <button type="button" id="savebeforeclosingcnclbtn" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" style="margin-right: -1em;">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--end delete account type list from delete icon-->


    <!--start delete account type list from delete icon-->
<!--
    <div id="deleteusermodalitem" *ngFor="let ex of selectedExpenseIdDetailsForItem" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="margin-top: 190px">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> Delete Item</h3>
            <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
            <p style="    font-size: 19px;
    margin-left: 6pc;
    padding: 29px 30px;">Are you confirm to delete this line item?</p>
            <div style="padding:0px 205px;    margin-top: -12px;">
              <button (click)="deleteItemLine(ex)" id="deletepopupcloseforitemSavebtn" class="btn btn-info btn-sm" style="width: 67px;">OK</button>
              <button id="deletepopupcloseforitem" class="btn btn-info btn-sm" data-dismiss="modal">CANCEL</button>
            </div>
          </div>
        </div>
      </div>
    </div>
-->
    <!--end delete account type list from delete icon-->

    <!--modal end-->

</div>
</div>
